import React, { useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import Container from '@mui/material/Container';

import Introduction from '../sections/Introduction.js';
import AboutUs from '../sections/AboutUs';
import ServiceFlow from '../sections/ServiceFlow';
import Features from '../sections/Features';
// import Mindverse from '../sections/Mindverse';
import GalleryCustomizedService from '../sections/Gallery_CustomizedService.js';
import GalleryStudentWorks from '../sections/Gallery_StudentWorks.js';
import Partners from '../sections/Partners.js';
import ContactUs from '../sections/ContactUs';
import background from '../../sources/Background/header.png';

function Home() {
  const location = useLocation();

  const levalRef = useRef(null);
  // const mindverseRef = useRef(null);
  const contactRef = useRef(null);
  

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  

  return (
    <Box
      sx={{
        height: 'auto',
        width: '100%',
        backgroundImage: `url(${background})`,
        backgroundPosition: "center top",
        backgroundSize: { xs: "cover", md: "100% auto" },
        backgroundRepeat: "no-repeat",
        backgroundColor: "#FADDC6",
        display:"flex",
        flexDirection:"column",
        pt: { xs: 12, md: 15 },
        margin: '0',
        overflowX: 'hidden'
      }}
    >
    
      <Box sx={{ pt: { xs: 4, md: 8 } }}>
        <Box id="introduction" sx={{ width: '100%', minHeight: { md: '70vh' }, display: 'flex', alignItems: 'center', pb: { xs: 10, md: 15 } }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 2560px)': { px: 40 } }}>
            <Introduction />
          </Container>
        </Box>

        <Box ref={levalRef} id="levav" py={7} sx={{ width: '100%', backgroundColor: '#fff5f0', overflow: 'hidden' }}>
        
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 2560px)': { px: 40 } }}>           
            <AboutUs />
          </Container>
        </Box>

        <Box id="service_flow" py={2} pb={7} sx={{ width: '100%', backgroundColor: '#fff5f0', overflow: 'hidden' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 2560px)': { px: 40 } }}>           
            <ServiceFlow />
          </Container>
        </Box>

        <Box id="features" py={7} pb={15} sx={{ width: '100%', backgroundColor: '#fff5f0' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 1536px)': { maxWidth: '1800px' }, '@media (min-width: 2560px)': { px: 40, maxWidth: '2400px' } }}>
            <Features />
          </Container>         
        </Box>

        {/* Mindverse section temporarily hidden
        <Box ref={mindverseRef} id="mindverse" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#ffebe2' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 2560px)': { px: 40 } }}>
            <Mindverse />
          </Container>          
        </Box>
        */}

        <Box id="gallery_CustomizedService" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#ffebe2' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 1536px)': { maxWidth: '1800px' }, '@media (min-width: 2560px)': { px: 40, maxWidth: '2400px' } }}>
            <GalleryCustomizedService />
          </Container>          
        </Box>

        <Box id="gallery_StudentWorks" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#ffebe2' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 1536px)': { maxWidth: '1800px' }, '@media (min-width: 2560px)': { px: 40, maxWidth: '2400px' } }}>
            <GalleryStudentWorks />
          </Container>
        </Box>
        
        <Box id="partners" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#fff5f0' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 1536px)': { maxWidth: '1800px' }, '@media (min-width: 2560px)': { px: 40, maxWidth: '2400px' } }}>
            <Partners />
          </Container>         
        </Box>

        <Box ref={contactRef} id="contactUs" py={7} pb={7} sx={{ width: '100%', backgroundColor: '#ffebe2' }}>
          <Container maxWidth={false} sx={{ px: { xs: 2, sm: 4, md: 8, lg: 12, xl: 20 }, '@media (min-width: 1536px)': { maxWidth: '1800px' }, '@media (min-width: 2560px)': { px: 40, maxWidth: '2400px' } }}>
            <ContactUs />
          </Container>
        </Box>

        
        
      </Box>
    
    </Box>
  );
}

export default Home;